import forex from '@/modules/forex'
import crypto from '@/modules/crypto'
import ib from '@/modules/IB'
import copytrade from '@/modules/copytrade'
import bonus from '@/modules/bonus'
import pamm from '@/modules/pamm'
import invest from '@/modules/invest'

const activeModules = process.env.VUE_APP_ACTIVE_MODULES.split(',')
const modules = {
  ...(activeModules.includes('FOREX') && { forex }),
  ...(activeModules.includes('CRYPTO') && { crypto }),
  ...(activeModules.includes('IB') && { ib }),
  ...(activeModules.includes('COPYTRADE') && { copytrade }),
  ...(activeModules.includes('BONUS') && { bonus }),
  ...(activeModules.includes('PAMM') && { pamm }),
  ...(activeModules.includes('INVEST') && { invest }),
}

export default modules
